// src/api/auth.ts
// API-клиент для аутентификации + 2FA
import api from './client';

export interface LoginResponse {
  token?: string;
  refreshToken?: string;
  user?: any;
  requires2FA?: boolean;
  tempToken?: string;
}

export interface TwoFactorStatus {
  enabled: boolean;
  configuredAt: string | null;
  backupCodesCount: number;
}

export interface TwoFactorSetup {
  secret: string;
  qrCode: string;   // data:image/png;base64,...
  issuer: string;
  account: string;
}

export interface TwoFactorEnableResult {
  ok: boolean;
  message: string;
  backupCodes: string[];  // 10 штук, показываем ОДИН раз
}

export const authApi = {
  // ─── Основные ───
  login: (email: string, password: string) =>
    api.post<LoginResponse>('/auth/login', { email, password }).then(r => r.data),

  logout: () => api.post('/auth/logout', {}).then(r => r.data),

  me: () => api.get('/auth/me').then(r => r.data),

  // ─── 2FA ───
  get2FAStatus: () =>
    api.get<TwoFactorStatus>('/auth/2fa/status').then(r => r.data),

  setup2FA: () =>
    api.post<TwoFactorSetup>('/auth/2fa/setup', {}).then(r => r.data),

  enable2FA: (code: string) =>
    api.post<TwoFactorEnableResult>('/auth/2fa/enable', { code }).then(r => r.data),

  disable2FA: (password: string, code: string) =>
    api.post('/auth/2fa/disable', { password, code }).then(r => r.data),

  verify2FA: (tempToken: string, code: string) =>
    api.post<LoginResponse>('/auth/2fa/verify', { tempToken, code }).then(r => r.data),
};
